import isElement from "lodash.iselement";
import CartEntry from "../components/cartEntry.js";

class Cart {
  constructor() {
    this.entries = [];
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
  }
  init() {
    this.base = document.querySelector(".incart");
    if (!isElement(this.base)) return;
    this._controls = {
      selectAll: this.base.querySelector(".incart__selectall"),
      removeSelected: this.base.querySelector(".incart__removeselected"),
      mobileSelectAll: this.base.querySelector(
        ".incart__m-control:first-child"
      ),
      mobileRemoveSelected: this.base.querySelector(
        ".incart__m-control:last-child"
      )
    };
    // Event listeners
    if (this._controls.selectAll) {
      this._controls.selectAll.addEventListener(
        "click",
        this.selectAll.bind(this)
      );
    }
    if (this._controls.removeSelected) {
      this._controls.removeSelected.addEventListener(
        "click",
        this.removeSelected.bind(this)
      );
    }
    if (this._controls.mobileSelectAll) {
      this._controls.mobileSelectAll.addEventListener(
        "click",
        this.selectAll.bind(this)
      );
    }
    if (this._controls.mobileRemoveSelected) {
      this._controls.mobileRemoveSelected.addEventListener(
        "click",
        this.removeSelected.bind(this)
      );
    }
    this.entries = [...this.base.querySelectorAll(".entry")].map(
      entry => new CartEntry(entry)
    );
  }
  selectAll() {
    this.entries.forEach(entry => entry.setChecked());
  }
  removeSelected() {
    this.entries
      .filter(entry => entry.isChecked())
      .forEach(entry => entry.remove());
  }
}

export default Cart;



// WEBPACK FOOTER //
// ./src/js/apps/cart.js